/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormControl from './FormControl';
import FormFocus from '../utils/FormFocus';
import { StyledButton, StyledButtonGroup } from './BooleanInput.styled';
function BooleanInput(_ref) {
  var disabled = _ref.disabled,
    disableRipple = _ref.disableRipple,
    fullWidth = _ref.fullWidth,
    helperText = _ref.helperText,
    helperTextPlacement = _ref.helperTextPlacement,
    label = _ref.label,
    required = _ref.required,
    onChange = _ref.onChange,
    edges = _ref.edges,
    value = _ref.value,
    showError = _ref.showError,
    errorMessage = _ref.errorMessage,
    trueLabel = _ref.trueLabel,
    falseLabel = _ref.falseLabel,
    parseBool = _ref.parseBool,
    name = _ref.name,
    parseValue = _ref.parseValue;
  var _useState = useState(true),
    indeterminate = _useState[0],
    setIndeterminate = _useState[1];
  var _useState2 = useState(true),
    checked = _useState2[0],
    setChecked = _useState2[1];
  var hasError = showError && errorMessage;
  useEffect(function () {
    if (value !== null && value !== '' && value !== undefined) {
      setIndeterminate(false);
      setChecked(parseBool(value));
    }
  }, [value, parseBool]);
  var handleChange = function handleChange(e, bool) {
    e.preventDefault();
    onChange(parseValue(bool));
  };
  return /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: fullWidth,
    label: label,
    name: name,
    helperText: helperText,
    helperTextPlacement: helperTextPlacement,
    disabled: disabled,
    required: required,
    showError: showError,
    errorMessage: errorMessage,
    edges: edges
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormFocus, {
    name: name
  }), /*#__PURE__*/React.createElement(StyledButtonGroup, {
    edges: edges
  }, /*#__PURE__*/React.createElement(StyledButton, {
    variant: indeterminate || !checked ? 'outlined' : 'contained',
    onClick: function onClick(e) {
      return handleChange(e, true);
    },
    disableElevation: true,
    disableRipple: disableRipple,
    disableTouchRipple: disableRipple,
    disableFocusRipple: disableRipple,
    type: "button",
    indeterminate: indeterminate ? 'yes' : 'no',
    checked: checked,
    required: required,
    selected: !indeterminate && checked,
    error: hasError ? 'yes' : 'no'
  }, trueLabel), /*#__PURE__*/React.createElement(StyledButton, {
    variant: indeterminate || checked ? 'outlined' : 'contained',
    onClick: function onClick(e) {
      return handleChange(e, false);
    },
    disableElevation: true,
    disableRipple: disableRipple,
    disableTouchRipple: disableRipple,
    disableFocusRipple: disableRipple,
    type: "button",
    indeterminate: indeterminate ? 'yes' : 'no',
    checked: checked,
    required: required,
    selected: !indeterminate && !checked,
    error: hasError ? 'yes' : 'no'
  }, falseLabel))));
}
BooleanInput.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The input name.
   */
  name: PropTypes.string.isRequired,
  /**
   * Whether or not the 'Yes' option is selected. Pass null if indeterminate.
   */
  value: PropTypes.any,
  /**
   * If `true`, the buttons will be disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the buttons will not have ripple effect when clicked.
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the buttons will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,
  /**
   * Label for the left button
   */
  trueLabel: PropTypes.string,
  /**
   * Label for the right button
   */
  falseLabel: PropTypes.string,
  /**
   * The helper text content.
   */
  helperText: PropTypes.string,
  /**
   * Placed the helper text above or below the input.
   */
  helperTextPlacement: PropTypes.oneOf(['above', 'below']),
  /**
   * The label content.
   */
  label: PropTypes.string,
  /**
   * If `true`, the label is displayed as required and the `input` element` will be required.
   */
  required: PropTypes.bool,
  /**
   * Function to change input value
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Whether or not to display an error message (if there is a message to display).
   */
  showError: PropTypes.bool,
  /**
   * The error message to display if showError === true
   */
  errorMessage: PropTypes.string,
  /**
   * Make button edges rounded or square
   */
  edges: PropTypes.oneOf(['normal', 'rounded', 'sharp']),
  /**
   * Function for parsing the value as a bool to determine which button is currently selected (true = left)
   */
  parseBool: PropTypes.func,
  /**
   * Function for parsing the value back
   */
  parseValue: PropTypes.func
} : {};
BooleanInput.defaultProps = {
  disabled: false,
  disableRipple: false,
  fullWidth: false,
  helperText: '',
  helperTextPlacement: 'above',
  label: '',
  required: false,
  showError: false,
  errorMessage: '',
  edges: 'normal',
  trueLabel: 'Yes',
  falseLabel: 'No',
  parseBool: function parseBool(value) {
    return !!value;
  },
  parseValue: function parseValue(value) {
    return !!value;
  },
  value: null
};
export default BooleanInput;